// src/ui/RichTextRenderer.jsx
import React, { useMemo } from "react";
import DOMPurify from "dompurify";

export default function RichTextRenderer({ html }) {
  const clean = useMemo(() => DOMPurify.sanitize(html || ""), [html]);
  return (
    <article
      className="prose prose-zinc max-w-none prose-img:rounded-xl prose-img:border prose-img:border-gray-200 prose-pre:bg-gray-900 prose-pre:text-white"
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}
